import AuthMixin from '@/components/mixins/auth-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'
import { fetchAuthSession as AmplifyFetchAuthSession } from 'aws-amplify/auth'

export default {
  name: 'componentStructure',
  inject: [
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {
  },
  props: {
    data: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {
      title: 'componentStructure'
    }
  },
  methods: {
    handleAcceptBtnClick () {
      this.sendSignedInEvent()
      const apiRequest = () => {
        this.$utils.mainLoader(true)
        const requestData = { tos_accept_date: 'now' }
        this.$api.patch(`${CONFIG.API_BASE_URL}/group/me`, requestData)
          .then(async response => {
            localStorage.removeItem('aryaShowTOS')
            // Call fetchAuthSession with forceRefresh to ensure that the user session is updated with the latest TOS acceptance information.
            await AmplifyFetchAuthSession({ forceRefresh: true })
            this.$utils.mainLoader(false)
            this.$router.push('/loginok', () => {})
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }
      apiRequest()
    },
    downloadItem (docName) {
      let url = '/static/docs'
      let label = ''

      if (docName === 'termsOfService') {
        url += '/Terms of Service.pdf'
        label = 'Terms of Service.pdf'
      } else if (docName === 'privacyPolicy') {
        url += '/Privacy Notice.pdf'
        label = 'Privacy Notice.pdf'
      }

      this.$utils.downloadDocument({ url, label })
    }
  },
  mounted () {
    useMixpanel().track('Terms of services')
  }
}
